import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
  Badge,
} from '@nextui-org/react';
import { useInfiniteQuery } from '@tanstack/react-query';
import React, { useState, useEffect, Fragment } from 'react';
import { IoNotifications } from 'react-icons/io5';
import { getAllNotification } from './querys';
import moment from 'moment';
import { useInView } from 'react-intersection-observer';
import Loading from '../Loading/Loading';
import { useSelector } from 'react-redux';
import { decryptData } from '../../utils/encryptData';
import ViewNotification from './ViewNotification';

function NoficationDropdown() {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const { em, uid } = useSelector((state) => state.auth);
  const email = decryptData(em);
  const user_id = decryptData(uid);

  const { ref, inView } = useInView();

  const { data, isFetchingNextPage, fetchNextPage, isLoading, hasNextPage } =
    useInfiniteQuery({
      queryKey: ['notification', email],
      queryFn: async ({ pageParam }) =>
        getAllNotification({ pageParam, email }),
      initialPageParam: 1,
      getNextPageParam: (lastPage) => {
        const currentPage = lastPage?.page;
        const totalPages = lastPage?.pages;
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    });

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView]);

  //unreade msg count
  const unreadCount = data?.pages?.reduce((total, page) => {
    return total + page?.messages.filter((message) => !message.read).length;
  }, 0);

  return (
    <>
      <Badge
        color="danger"
        content={unreadCount}
        isInvisible={unreadCount === 0}
        shape="circle"
        className="left-1 top-2"
      >
        <Button
          isIconOnly
          onPress={onOpen}
          variant="flat"
          className="bg-transparent border-none"
        >
          <IoNotifications
            size={25}
            className="hover:text-btn-color duration-250"
          />
        </Button>
      </Badge>
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        scrollBehavior="inside"
        placement="center"
        size="3xl"
        className="md:max-h-[600px] mt-20"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col text-gray-200 items-center justify-center">
                Notification
              </ModalHeader>
              <ModalBody>
                {isLoading ? (
                  <Loading isLoading={true} />
                ) : data.pages.length === 0 ? (
                  <p className="text-gray-300 text-center mt-5 text-mobile-font text-xs md:text-sm">
                    No Notification
                  </p>
                ) : (
                  data.pages.map((page, pageIndex) => (
                    <Fragment key={pageIndex}>
                      {page.messages.map((item, index) => {
                        const isRead = item.readBy.some(
                          (readEntry) => readEntry.userId === user_id
                        );

                        return (
                          //read = true == read, read = false == unread
                          <div
                            key={index}
                            className={`border p-2 -mx-3 text-gray-200 rounded-lg cursor-pointer ${
                              !isRead
                                ? 'bg-neutral-800 hover:bg-neutral-700 border-gray-800'
                                : 'bg-neutral-900 border-radius-md border-gray-800 hover:bg-neutral-950'
                            }`}
                          >
                            <p
                              className={`text-sm mb-1 line-clamp-1 capitalize ${
                                !isRead
                                  ? 'text-gray-100'
                                  : 'text-gray-500 italic '
                              }`}
                            >
                              {/* {item.type} */}
                              finzaid
                            </p>
                            <p
                              className={`text-xs line-clamp-2 mb-1 mt-1 ${
                                !isRead
                                  ? 'text-gray-300'
                                  : 'text-gray-500 italic'
                              }`}
                            >
                              {item.message}
                            </p>
                            <div className="flex items-center justify-between">
                              <p
                                className={`text-xs ${
                                  !isRead
                                    ? 'text-gray-400'
                                    : 'text-gray-500 italic'
                                }`}
                              >
                                {moment(data?.createdAt).format('llll')}
                              </p>

                              <div
                                className={'items-center justify-center flex'}
                              >
                                <ViewNotification
                                  data={item}
                                  userId={user_id}
                                  isRead={isRead}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Fragment>
                  ))
                )}
                {!hasNextPage && (
                  <h5 className="text-gray-300 text-center mt-2 text-xs md:text-sm">
                    No Notification
                  </h5>
                )}
                <div ref={ref} className="my-8">
                  {isFetchingNextPage ? (
                    <Loading isLoading={isFetchingNextPage} />
                  ) : null}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}

export default NoficationDropdown;
